import { jsx as _jsx } from "react/jsx-runtime";
import { Flag } from './Flag';
export const STATUS = Object.freeze({
    ALERT: 'ALERT',
    ERROR: 'ERROR',
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
});
const STATUS_PROPS = {
    ALERT: {
        bg: 'mandarine',
        iconName: 'triangle-exclamation',
    },
    ERROR: {
        bg: 'fire',
        iconName: 'circle-exclamation',
    },
    INFO: {
        bg: 'primary',
        iconName: 'circle-info',
    },
    SUCCESS: {
        bg: 'grass',
        iconName: 'circle-check',
    },
};
export const FlagStatus = ({ maxWidth, status, text }) => (_jsx(Flag, { bg: STATUS_PROPS[status].bg, color: "white", iconColor: "white", iconName: STATUS_PROPS[status].iconName, maxWidth: maxWidth, text: text }));
//# sourceMappingURL=FlagStatus.js.map